@if (showWidget()) {
  <div class="health-nav-shell">
    <button
      type="button"
      class="fab"
      [disabled]="!assistantAvailable()"
      [attr.aria-label]="
        assistantAvailable()
          ? isOpen()
            ? 'Close PeerLiv assistant'
            : 'Open PeerLiv assistant'
          : 'PeerLiv assistant is unavailable'
      "
      [attr.aria-expanded]="isOpen()"
      aria-controls="health-nav-panel"
      (click)="togglePanel()"
    >
      <span class="fab-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M20.5 11.8a7.8 7.8 0 0 1-8.3 7.8 8.5 8.5 0 0 1-3.4-.8L4 20l1.2-4.4a7.8 7.8 0 0 1-.9-3.8 8.1 8.1 0 0 1 16.2 0z" />
          <path d="M17.2 3.7v3.8M15.3 5.6h3.8" />
        </svg>
      </span>
      @if (hasUnread()) {
        <span class="fab-badge" aria-hidden="true"></span>
      }
    </button>

    @if (isOpen()) {
      <section
        id="health-nav-panel"
        class="panel"
        role="dialog"
        aria-label="PeerLiv assistant"
        aria-modal="false"
        @slideUp
      >
        <app-health-nav-chat
          [messages]="messages()"
          [assistantAvailable]="assistantAvailable()"
          [isStreaming]="isStreaming()"
          [errorMessage]="inlineNotice()"
          [noticeTone]="inlineNoticeTone()"
          [chips]="suggestionChips()"
          [contextualActions]="contextualActions()"
          [contextualActionMessageId]="contextualActionMessageId()"
          [withBottomNav]="withBottomNav"
          [guidedMode]="currentGuidedMode()"
          [loadingLabel]="loadingLabel()"
          [inputPlaceholder]="inputPlaceholder()"
          [inputHelperText]="inputHelperText()"
          [draftText]="inputText()"
          [focusRequest]="focusRequest()"
          (inputTextChange)="handleTextChange($event)"
          (sendMessage)="sendMessage($event)"
          (close)="closePanel(false)"
          (chipSelected)="sendChip($event)"
          (feedback)="sendFeedback($event.messageId, $event.sentiment)"
          (useDraft)="useDraft($event)"
          (refineDraft)="refineDraft($event)"
          (joinCommunity)="joinCommunity($event)"
          (showMoreResults)="showMoreResults($event)"
          (navigateAction)="navigateAction($event)"
          (clearGuidedMode)="clearGuidedMode()"
          (retry)="retryLastMessage()"
          (newChat)="startNewChat()"
        ></app-health-nav-chat>
      </section>
    }
  </div>
}
